<!--<search class="no-print"></search>-->
<style>
  .table {
    margin-bottom: 0;
  }

  .panel {
    margin-bottom: 15px;
  }
</style>
<div class="row" style="margin:10px 0px;">
  <div class="col-md-12">
    <div class="panel panel-default" style="border: none;">
      <div class="dashboarddatepicker">
        <label style="padding: 4px">Start Date
          <input type="date" class="form-control" [(ngModel)]="start_date"/>
        </label>
        <label style="padding: 4px">End Date
          <input type="date" class="form-control" [(ngModel)]="end_date"/>
        </label>
        <button class="btn btn-primary" style="margin-top: 9px" (click)="updateRanges()">
          Apply Date Range
        </button>
        <label class="dashboardlegend" (click)="DateIsCollapsed = !DateIsCollapsed">Date Range Legend
          <i *ngIf="DateIsCollapsed && !loading_legend"
             class="pull-left fa fa-chevron-down"></i>
          <i *ngIf="!DateIsCollapsed && !loading_legend" class="pull-left fa fa-chevron-up"></i>
          <li *ngFor="let range of date_ranges" style="list-style-type: none;" [ngbCollapse]="DateIsCollapsed">
            {{ get_quarter_label(range.start) + ': ' + range.start.format('LL')}} -
            {{range.end.format('LL')}} </li>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Sampling Activity Totals by Station
          </div>
          <div class="panel-body">
            <div *ngIf="loading_activity_counts"><i class="fa fa-spinner fa-pulse"></i></div>
            <div id="sampling_activity_table"></div>
          </div>
        </div>
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Advisory Activity by Type
          </div>
          <div class="panel-body">
            <div *ngIf="loading_activity_counts"><i class="fa fa-spinner fa-pulse"></i></div>
            <div id="advisory_activity_type_table"></div>
          </div>
        </div>
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Advisory Activity Totals by Beach and Type
          </div>
          <div class="panel-body">
            <div *ngIf="loading_beach_advisories"><i class="fa fa-spinner fa-pulse"></i></div>
            <div id="advisories_by_beach_table" [style.display]="loading_beach_advisories ? 'none' : ''"></div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Advisory Activity Totals by Station and Type
          </div>
          <div class="panel-body">
            <div *ngIf="loading_advisory_counts_by_station"><i class="fa fa-spinner fa-pulse"></i></div>
            <div id="advisory_by_station_table"></div>
          </div>
        </div>
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Submission Totals by Type
          </div>
          <div class="panel-body">
            <div *ngIf="loading_submissions"><i class="fa fa-spinner fa-pulse"></i></div>
            <div id="submissions_table"></div>
          </div>
        </div>
        <div class="panel panel-default printing">
          <div class="panel-heading">
            Submission Activity Totals
          </div>
          <div class="panel-body">
            <div *ngIf="loading_submissions"><i class="fa fa-spinner fa-pulse"></i></div>
            <div id="submissions_activities_table"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-default printing">
          <div class="panel-heading" (click)="AdvisoryIsCollapsed = !AdvisoryIsCollapsed" style="cursor: pointer;">
            <i *ngIf="AdvisoryIsCollapsed && !loading_advisory_counts_by_station"
               class="pull-left fa fa-chevron-down"></i>
            <i *ngIf="!AdvisoryIsCollapsed && !loading_advisory_counts_by_station"
               class="pull-left fa fa-chevron-up"></i>
            <span *ngIf="loading_advisory_counts_by_station"><i class="fa fa-spinner fa-pulse"></i> </span>

            Advisory Activity Exploration
          </div>
          <div class="panel-body" [ngbCollapse]="AdvisoryIsCollapsed">
            <div id="advisory_table"></div>
          </div>

        </div>
      </div>
      <div class="col-md-12">
        <div class="panel panel-default printing">
          <div class="panel-heading" (click)="SamplingIsCollapsed = !SamplingIsCollapsed" style="cursor: pointer;">
            <i *ngIf="SamplingIsCollapsed && !loading_activity_counts"
               class="pull-left fa fa-chevron-down"></i>
            <i *ngIf="!SamplingIsCollapsed && !loading_activity_counts" class="pull-left fa fa-chevron-up"></i>
            <span *ngIf="loading_activity_counts"><i class="fa fa-spinner fa-pulse"></i> </span>
            Sampling Activity Exploration
          </div>

          <div class="panel-body" [ngbCollapse]="SamplingIsCollapsed">
            <div id="sampling_table"></div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="panel panel-default printing">
          <div class="panel-heading" (click)="ResultIsCollapsed = !ResultIsCollapsed">
            <i *ngIf="ResultIsCollapsed && !loading_results"
               class="pull-left fa fa-chevron-down"></i>
            <i *ngIf="!ResultIsCollapsed && !loading_results" class="pull-left fa fa-chevron-up"></i>
            <span *ngIf="loading_results"><i class="fa fa-spinner fa-pulse"></i> </span>
            Result Exploration
          </div>
          <div class="panel-body" [ngbCollapse]="ResultIsCollapsed">
            <div id="result_table"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="print-only">

</div>
